export type ApiEnvelope<T> = {
  code: string;
  message: string;
  data: T;
};

export type TaskStatus = "pending" | "queued" | "running" | "completed" | "failed" | "cancelled";

export const APP_NAME = "exam";

export * from "./api";
export * from "./app-public-path";
export * from "./auth";
export * from "./auth-member-roles";
export * from "./auth-routes";
export * from "./browser";
export * from "./center-openapi-transport";
export * from "./date-time";
export * from "./dicts";
export * from "./error-utils";
export * from "./exam-routes";
export * from "./exam-score-records";
export * from "./identity-status";
export * from "./locale";
export * from "./locale-storage";
export * from "./markdown-editor-messages";
export * from "./oidc-routes";
export {
  type ApiRequestMethod,
  type ApiRequestOptions,
  type BrowserAppSessionBootstrapConfig,
  type BrowserAppSessionBootstrapResult,
  bootstrapBrowserAppSession,
  createOidcClientIdResolver,
  createSharedOidcUnauthorizedRecovery,
  createSsoSessionCoordinator,
  isDefaultOidcAuthRoutePath,
  isOidcInvalidClientError,
  logoutAndClearLocalSession,
  parseJsonResponse,
  readApiErrorDetail,
  readBrowserLocationPath,
  requestOidcToken,
  requestSsoLogout,
  type SharedOidcUnauthorizedRecoveryOptions,
  type SsoSessionApiClient,
  type StartOidcAuthorizationPrompt,
  type UnauthorizedSessionRecoveryContext,
  type UnauthorizedSessionRecoveryResult,
} from "./oidc-session/index";
export * from "./openapi-query";
export * from "./page-titles";
export * from "./platform";
export * from "./platform-overview";
export * from "./platform-urls";
export * from "./public-deployment-modes";
export * from "./runtime-access";
export * from "./semantic-enum";
export * from "./session";
export * from "./shared-resource-scope";
export * from "./sso-login-context";
export * from "./topology-node-icons";
export * from "./topology-x6-preview";
export * from "./url";
